import { useState, useRef, useEffect } from "react";
import { motion } from "framer-motion";

// Comparateur avant / après avec curseur glissant
export const BeforeAfter = ({ before, after, label = "" }) => {
  const [pos, setPos] = useState(50);
  const ref = useRef(null);
  const dragging = useRef(false);

  const move = (clientX) => {
    const rect = ref.current?.getBoundingClientRect();
    if (!rect) return;
    const p = ((clientX - rect.left) / rect.width) * 100;
    setPos(Math.max(0, Math.min(100, p)));
  };

  useEffect(() => {
    const up = () => (dragging.current = false);
    const mm = (e) => dragging.current && move(e.clientX);
    const tm = (e) => dragging.current && move(e.touches[0].clientX);
    window.addEventListener("mouseup", up);
    window.addEventListener("mousemove", mm);
    window.addEventListener("touchend", up);
    window.addEventListener("touchmove", tm);
    return () => {
      window.removeEventListener("mouseup", up);
      window.removeEventListener("mousemove", mm);
      window.removeEventListener("touchend", up);
      window.removeEventListener("touchmove", tm);
    };
  }, []);

  return (
    <div ref={ref} className="relative w-full aspect-[4/3] overflow-hidden rounded-2xl select-none cursor-ew-resize border border-line"
      onMouseDown={(e) => { dragging.current = true; move(e.clientX); }}
      onTouchStart={(e) => { dragging.current = true; move(e.touches[0].clientX); }}
    >
      <img src={after} alt="Après" className="absolute inset-0 w-full h-full object-cover" draggable={false} />
      <div className="absolute inset-0 overflow-hidden" style={{ width: `${pos}%` }}>
        <img src={before} alt="Avant" className="absolute inset-0 h-full object-cover max-w-none" style={{ width: ref.current?.offsetWidth || "100%" }} draggable={false} />
        <span className="absolute top-3 left-3 bg-forest/80 text-sand text-xs font-semibold px-3 py-1 rounded-full">Avant</span>
      </div>
      <span className="absolute top-3 right-3 bg-olive text-white text-xs font-semibold px-3 py-1 rounded-full">Après</span>
      <div className="absolute top-0 bottom-0 w-0.5 bg-white shadow" style={{ left: `${pos}%` }}>
        <div className="absolute top-1/2 -translate-y-1/2 -translate-x-1/2 w-9 h-9 rounded-full bg-white shadow-lift grid place-items-center text-forest">
          ⇆
        </div>
      </div>
      {label && <span className="absolute bottom-3 left-3 bg-sand/90 text-forest text-xs font-medium px-3 py-1 rounded-full">{label}</span>}
    </div>
  );
};
